<template>
  <div>
    <!-- FILTER -->
    <div class="mt-3">
      <b-row>
        <b-col md="10">
          <b-card class="shadow-sm">
            <b-card-header class="d-flex justify-content-between align-items-center">
              <h4 class="card-title">
                Informasi Tagihan Pelanggan
              </h4>
            </b-card-header>
            <b-card-body>
              <form action="">
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      label="Nama"
                      label-for="f-cust-id"
                      label-cols-md="4"
                    >
                      <v-select
                        id="f-cust-id"
                        v-model="filter.cust_id"
                        :options="custOpt"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Tanggal Transaksi"
                      label-for="f-range-date"
                      label-cols-md="4"
                    >
                      <flat-pickr
                        id="f-range-date"
                        v-model="filter.rangeDate"
                        class="form-control"
                        :config="{ mode: 'range', enableTime: true, dateFormat: 'Y-m-d H:i'}"
                        @on-change="(date) => {
                          filter.startDate = date[0]
                          filter.endDate = date[1]
                        }"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Saldo Deposit"
                      label-for="f-in-balance"
                      label-cols-md="4"
                    >
                      <b-input-group>
                        <b-form-input
                          id="f-in-balance"
                          :value="new Intl.NumberFormat('en-US').format(filter.depoBalance)"
                          type="text"
                          readonly
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Total Tagihan"
                      label-for="f-out-balance"
                      label-cols-md="4"
                    >
                      <b-input-group>
                        <b-form-input
                          id="f-out-balance"
                          :value="new Intl.NumberFormat('en-US').format(filter.totalBill)"
                          type="text"
                          readonly
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2 p-1">
                  <b-button
                    variant="info"
                    @click="getList()"
                  >
                    Cari Tagihan
                  </b-button>
                  <b-button
                    variant="outline-info"
                    class="ml-1"
                    @click="handleCustomerPayment()"
                  >
                    Bayar Tagihan {{ countedRows==0?'':`(${countedRows})` }}
                  </b-button>
                </b-row>
              </form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      @on-selected-rows-change="updateSelectedRows"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <span v-if="props.column.field=== 'grand_total'">
          {{ new Intl.NumberFormat('en-US').format(props.formattedRow[props.column.field]) }}
        </span>

        <span v-else-if="props.column.field=== 'payment_outs'">
          {{ new Intl.NumberFormat('en-US').format(props.formattedRow[props.column.field]) }}
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect,
  BButton, BCardBody, BCardHeader, BCard, BCol, BRow, BInputGroup,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BCardBody,
    BCardHeader,
    BRow,
    BCard,
    BCol,
    BInputGroup,
    flatPickr,
    vSelect,
  },
  data() {
    const today = new Date()
    const start = new Date(today.setHours(0, 0, 0))
    const end = new Date(); end.setHours(23, 59, 0)

    return {
      pageLength: 10,
      dir: false,
      custOpt: [],
      selectedRows: [],
      countedRows: 0,
      filter: {
        rangeDate: [start, end],
        startDate: start,
        endDate: end,
        cust_id: {},
        depoBalance: 0,
        totalBill: 0,
      },
      typeMaster: {
        1: 'Pembelian',
        2: 'Penjualan',
        3: 'Lainnya',
        4: 'Deposit Pelanggan',
      },
      columns: [
        {
          label: 'No',
          field: 'trx_no',
          sortable: true,
        },
        {
          label: 'Tanggal Transaksi',
          field: 'trx_date',
          sortable: true,
        },
        {
          label: 'Kurang Bayar',
          field: 'payment_outs',
          sortable: true,
        },
        {
          label: 'Total',
          field: 'grand_total',
          sortable: true,
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    // GET CASH OPTION
    this.$http.get('/customer')
      .then(res => {
        this.custOpt = res.data.data.data.map(cust => ({
          value: cust.id,
          title: cust.name,
        }))
      })
  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      const pad = n => (n < 10 ? `0${n}` : n)
      const yy = String(date.getFullYear()).slice(2)
      const mm = pad(date.getMonth() + 1)
      const dd = pad(date.getDate())
      const hh = pad(date.getHours())
      const min = pad(date.getMinutes())
      return `${yy}-${mm}-${dd} ${hh}:${min}`
    },
    updateSelectedRows(params) {
      this.selectedRows = params.selectedRows
      this.countedRows = this.selectedRows.length
    },
    getList() {
      console.log(this.filter.startDate, this.filter.endDate)
      const payload = {
        cust_id: this.filter.cust_id.value,
        start_date: this.formatDate(this.filter.startDate),
        end_date: this.formatDate(this.filter.endDate),
      }

      this.$http.post('/customer-bill', payload)
        .then(res => {
          const start = new Date(new Date(res.data.start_date))
          const end = new Date(new Date(res.data.end_date))

          this.filter.cash_id = {
            value: res.data.cash_id,
            title: res.data.cash_name,
          }
          this.filter.rangeDate = [start, end]
          this.filter.startDate = start
          this.filter.endDate = end
          this.filter.depoBalance = res.data.customer.depo_balance

          this.filter.totalBill = 0

          this.rows = res.data.data.map(sales => {
            this.filter.totalBill += parseInt(sales.grand_total, 10)
            return {
              trx_no: sales.trx_no,
              trx_date: sales.trx_date,
              payment_outs: sales.grand_total - (sales.payment_sum_nominal ?? 0),
              grand_total: sales.grand_total,
            }
          })
        })
    },
    handleCustomerPayment() {
      if (this.selectedRows.length === 0) {
        this.$bvToast.toast('Pilih tagihan yang akan dibayar', {
          title: 'Peringatan',
          variant: 'warning',
          solid: true,
        })
        return
      }

      const totalSelectedBill = this.selectedRows.reduce((sum, row) => sum + row.payment_outs, 0)

      if (this.filter.depoBalance < totalSelectedBill) {
        this.$bvToast.toast('Total Deposit tidak cukup untuk melunasi tagihan', {
          title: 'Peringatan',
          variant: 'warning',
          solid: true,
        })
        return
      }
      const payload = {
        trx_data: this.selectedRows.map(row => ({
          trx_no: row.trx_no,
          payment_outs: row.payment_outs,
        })),
        cust_id: this.filter.cust_id.value,
      }

      console.log(payload)
      // POST PAYMENT
      this.$http.post('/customer-bill-payment', payload)
        .then(() => {
          this.$bvToast.toast('Pembayaran berhasil', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          this.getList()
        })
        .catch(err => {
          console.error(err)
          this.$bvToast.toast('Terjadi kesalahan saat memproses pembayaran', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
